import React from 'react';
import './styles.css';

export default function Divider() {
  return <hr className="divider" />;
}
